import React from 'react';
import { inject, observer } from 'mobx-react';
import { Select, Button } from 'antd';
import './index.less'
import CommonStore from '@/stores/commonStore';
const { Option } = Select;

interface noPermissionProps {
  CommonStore: typeof CommonStore;
}

@inject('CommonStore')
@observer
class noPermission extends React.Component<noPermissionProps, any> {
  constructor(props: noPermissionProps) {
    super(props);
    this.state = {
      submit_acive: false,
      permission_type: undefined
    }
  }
  componentDidMount() {
  }
  handleChange = (_: any, obj: any) => {
    if (obj.key) {
      this.setState({
        permission_type: obj.key,
        submit_acive: true
      })
    }
  }

  submit = () => {
    let url = 'https://upm.didiglobal.com/upm2-static/main/835'
    if (this.state.permission_type === 'isPMRD') {
      url = 'https://upm.didiglobal.com/upm2-static/main/newapply?appId=835&identifying=role&id=14211447'
    } else if (this.state.permission_type === 'isOther') {
      url = 'https://upm.didiglobal.com/upm2-static/main/newapply?appId=835&identifying=role&id=14211591'
    }
    window.open(url, '_blank')
  }

  render() {
    const TEXTS = this.props.CommonStore.curLocales || {}
    return (
      <div className='no-permissions-wrap'>
        <div className='no-permissions'>
          <div className="header">
            <span className="warning"></span>
            <span className="no-permission-text">{TEXTS['CS_Tools_Ark_System_Quick_Access_for_Permission_Application_Sorry_permissions_nBRG']}</span>
          </div>
          <div className="isCS-wrap">
            <p className="isCS">{TEXTS['CS_Tools_Ark_System_Quick_Access_for_Permission_Application_Customer_service_vLUC']}</p>
            <p className="isCScontent">{TEXTS['CS_Tools_Ark_System_Quick_Access_for_Permission_Application_Hello_permissions_SDxI']}</p>
          </div>
          <div className="isNoCS-wrap">
            <p className="isNoCS">{TEXTS['CS_Tools_Ark_System_Quick_Access_for_Permission_Application_Customer_service_oPui']}</p>
            <p className="isNoCS-title">
              {TEXTS['CS_FE_You_can_yIrn']}
            </p>
            <p className="isNoCS-title">
              {TEXTS['CS_FE_If_you_lCHy']}
            </p>
            <p className="isNoCS-con">
              {TEXTS['CS_FE_Select_Product_VbhT']}
            </p>
            <p className="isNoCS-title">
              {TEXTS['CS_FE_If_you_WAuP']}
            </p>
            <p className="isNoCS-con">
              {TEXTS['CS_FE_Choose_Ark_VJpl']}
            </p>
            <a className="detailHref" rel="noopener noreferrer" target="_blank" href="http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=347394842">{TEXTS['CS_Tools_Ark_System_Quick_Access_for_Permission_Application_See_permissions_OzjQ']}</a>
          </div>
          <div className="select-conent">
            <p className="selectPermission">{TEXTS['CS_Tools_Ark_System_Quick_Access_for_Permission_Application_Permission_Kapv']}</p>
            <div className="select-wrap">
              <Select style={{ width: 400 }} onSelect={this.handleChange}>
                <Option value="产品研发角色" key='isPMRD'>{TEXTS['CS_FE_Product_R_RxVt']}</Option>
                <Option value="方舟访客角色" key='isOther'>{TEXTS['CS_FE_Ark_Visitor_pMCT']}</Option>
              </Select>
              <div className="submit-wrap">
                <Button onClick={this.submit} disabled={!this.state.submit_acive} type="primary" >{TEXTS['CS_system_Submission_cEep']}</Button>
              </div>
            </div>
          </div>
          <div className="warning-img"></div>
        </div>
      </div>
    )
  }
}

export default noPermission